import * as types from './types';

function setAllCarrierData(data) {
    return {
        payload: data,
        type: types.SET_ALL_CARRIER_DATA,
    };
}

function setCarrierData(carrierCode, data) {
    return {
        meta: carrierCode,
        payload: data,
        type: types.SET_CARRIER_DATA,
    };
}

export {
    setAllCarrierData,
    setCarrierData,
};
